// 銷售訂單資料模型
// Sales Order Data Model

import { products } from './inventoryData';

// 銷售訂單頭檔
export const salesOrders = [
  {
    id: 'so-2025-0001',
    customerName: '台灣電子股份有限公司',
    customerCode: 'CUST-001',
    orderDate: '2025-01-05',
    deliveryDate: '2025-01-20',
    status: 'confirmed', // draft, confirmed, processing, shipped, completed, cancelled
    totalAmount: 125000,
    currency: 'TWD',
    paymentTerms: '30天',
    shippingMethod: '貨運',
    salesPerson: '李小華',
    notes: '客戶要求週一至週五上午9點至下午3點間交貨',
    createdAt: '2025-01-05T10:30:00',
    updatedAt: '2025-01-06T14:15:00'
  },
  {
    id: 'so-2025-0002',
    customerName: '香港科技有限公司',
    customerCode: 'CUST-002',
    orderDate: '2025-01-08',
    deliveryDate: '2025-01-25',
    status: 'processing',
    totalAmount: 85000,
    currency: 'HKD',
    paymentTerms: '預付款',
    shippingMethod: '空運',
    salesPerson: '王大明',
    notes: '急件，請優先處理',
    createdAt: '2025-01-08T09:45:00',
    updatedAt: '2025-01-09T11:20:00'
  },
  {
    id: 'so-2025-0003',
    customerName: '新加坡電子工業私人有限公司',
    customerCode: 'CUST-003',
    orderDate: '2025-01-10',
    deliveryDate: '2025-02-05',
    status: 'confirmed',
    totalAmount: 230000,
    currency: 'SGD',
    paymentTerms: '60天',
    shippingMethod: '海運',
    salesPerson: '張小玲',
    notes: '大型訂單，需提前準備',
    createdAt: '2025-01-10T14:30:00',
    updatedAt: '2025-01-11T10:05:00'
  },
  {
    id: 'so-2025-0004',
    customerName: '台北科技應用有限公司',
    customerCode: 'CUST-004',
    orderDate: '2025-01-15',
    deliveryDate: '2025-01-30',
    status: 'draft',
    totalAmount: 45000,
    currency: 'TWD',
    paymentTerms: '15天',
    shippingMethod: '貨運',
    salesPerson: '李小華',
    notes: '等待客戶確認最終數量',
    createdAt: '2025-01-15T16:20:00',
    updatedAt: '2025-01-15T16:20:00'
  }
];

// 銷售訂單明細
export const salesOrderItems = [
  // SO-2025-0001 Items
  {
    id: 'soi-2025-0001-001',
    orderId: 'so-2025-0001',
    productId: products[0].id,
    productName: products[0].name,
    productSku: products[0].sku,
    quantity: 50,
    unitPrice: 1500,
    unit: '個',
    lineTotal: 75000,
    deliveryDate: '2025-01-20',
    notes: '標準規格'
  },
  {
    id: 'soi-2025-0001-002',
    orderId: 'so-2025-0001',
    productId: products[2].id,
    productName: products[2].name,
    productSku: products[2].sku,
    quantity: 25,
    unitPrice: 2000,
    unit: '個',
    lineTotal: 50000,
    deliveryDate: '2025-01-20',
    notes: '客戶指定藍色款式'
  },
  
  // SO-2025-0002 Items
  {
    id: 'soi-2025-0002-001',
    orderId: 'so-2025-0002',
    productId: products[1].id,
    productName: products[1].name,
    productSku: products[1].sku,
    quantity: 30,
    unitPrice: 1800,
    unit: '個',
    lineTotal: 54000,
    deliveryDate: '2025-01-25',
    notes: ''
  },
  {
    id: 'soi-2025-0002-002',
    orderId: 'so-2025-0002',
    productId: products[3].id,
    productName: products[3].name,
    productSku: products[3].sku,
    quantity: 10,
    unitPrice: 3100,
    unit: '個',
    lineTotal: 31000,
    deliveryDate: '2025-01-25',
    notes: '高規格版本'
  },
  
  // SO-2025-0003 Items
  {
    id: 'soi-2025-0003-001',
    orderId: 'so-2025-0003',
    productId: products[0].id,
    productName: products[0].name,
    productSku: products[0].sku,
    quantity: 100,
    unitPrice: 1450,
    unit: '個',
    lineTotal: 145000,
    deliveryDate: '2025-02-05',
    notes: '大量訂購折扣'
  },
  {
    id: 'soi-2025-0003-002',
    orderId: 'so-2025-0003',
    productId: products[4].id,
    productName: products[4].name,
    productSku: products[4].sku,
    quantity: 20,
    unitPrice: 4250,
    unit: '個',
    lineTotal: 85000,
    deliveryDate: '2025-02-05',
    notes: '新型號'
  },
  
  // SO-2025-0004 Items
  {
    id: 'soi-2025-0004-001',
    orderId: 'so-2025-0004',
    productId: products[2].id,
    productName: products[2].name,
    productSku: products[2].sku,
    quantity: 15,
    unitPrice: 2000,
    unit: '個',
    lineTotal: 30000,
    deliveryDate: '2025-01-30',
    notes: ''
  },
  {
    id: 'soi-2025-0004-002',
    orderId: 'so-2025-0004',
    productId: products[5].id,
    productName: products[5].name,
    productSku: products[5].sku,
    quantity: 5,
    unitPrice: 3000,
    unit: '個',
    lineTotal: 15000,
    deliveryDate: '2025-01-30',
    notes: '待確認最終數量'
  }
];

// 銷售訂單狀態歷史
export const salesOrderStatusHistory = [
  {
    orderId: 'so-2025-0001',
    status: 'draft',
    timestamp: '2025-01-05T10:30:00',
    user: '李小華',
    notes: '初始建立訂單'
  },
  {
    orderId: 'so-2025-0001',
    status: 'confirmed',
    timestamp: '2025-01-06T14:15:00',
    user: '張經理',
    notes: '訂單已確認'
  },
  {
    orderId: 'so-2025-0002',
    status: 'draft',
    timestamp: '2025-01-08T09:45:00',
    user: '王大明',
    notes: '初始建立訂單'
  },
  {
    orderId: 'so-2025-0002',
    status: 'confirmed',
    timestamp: '2025-01-08T15:30:00',
    user: '張經理',
    notes: '訂單已確認'
  },
  {
    orderId: 'so-2025-0002',
    status: 'processing',
    timestamp: '2025-01-09T11:20:00',
    user: '生產部門',
    notes: '訂單已進入生產階段'
  }
];
